import AVText from 'src/components/elements/AVText';
import Styles from '../../Styles';
import {
  Dimensions,
  Image,
  Platform,
  StyleProp,
  TextStyle,
  View,
} from 'react-native';
import Localized from 'src/constants/AppStrings';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import CustomTextInput from 'src/components/elements/CustomTextInput';
import Settings from 'src/Settings';
import Svg, {Path, Defs, LinearGradient, Stop, G} from 'react-native-svg';
import {capitalizeFirstWord} from 'src/Util';
import TRialBlazerIconWeb from 'src/components/img/svg/rewards/TRialBlazerIconWeb';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import BuildTypes from 'src/constants/BuildTypeConstants';

export function getFocusAwareStatusBar() {
  return null;
}
export function linkExistingAccountStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    container: {
      flex: 1,
      padding: Styles.Spacing.m3,
    },
    title: {
      fontSize: getLayoutDescriber().headerFontSize(),
      color: Styles.darkColor,
    },
  };
}

export function getWelcomeViewBckGrndStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    overlay: {},
    view: {
      flex: 1,
    },
  };
}

export function getWelcomeOverLayImage() {
  return null;
}
export function getRedeemColor() {
  return {
    backgroundColor: '#066DFF',
    borderTopColor: '#066DFF',
    borderBottomColor: '#066DFF',
    borderLeftColor: '#066DFF',
    borderRightColor: '#066DFF',
    borderColor: '#066DFF',
  };
}
export function renderYourBalanceRewardLbl(_styles, _accountStr) {
  return (
    <>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
        style={_styles.payBalance}
      >
        {`${Localized.Labels.your_balance}: `}
        <AVFormattedCurrency
          testID={'balanceFormattedCurrency'}
          accessibilityLabel={
            _accountStr.getAccountBalance()
              ? `$${_accountStr.getAccountBalance().toString()}`
              : '0'
          }
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          style={_styles.payBalance}
          value={_accountStr.getAccountBalance() ?? 0}
          currency={_accountStr.getCurrency()}
        />
      </AVText>
    </>
  );
}

export function getOrTextDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    orText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      textTransform: 'uppercase',
    },
    solidLine: {
      backgroundColor: '#999',
    },
  };
}

export function getLineContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    lineContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: Styles.Spacing.m1,
    },
  };
}
export function getPasswordLoginTextStyleDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    passwordLoginText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    passwordLoginTextColor: {
      color: Styles.Colors.PayNew.primary01,
      textDecorationColor: Styles.Colors.PayNew.primary01,
    },
  };
}
export function getWelcomeStatusBarStyleDescriptor(): string {
  return Styles.loginBackground;
}
export function getVersionTextDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    versionText: {
      color: Styles.Colors.PayNew.primary01,
      marginLeft: Styles.Spacing.m3,
    },
  };
}
export function getLogoContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    logoContainer: {
      alignSelf: 'center',
      height: Styles.Heights.h3,
      justifyContent: 'center',
      paddingTop: Styles.Spacing.m1,
      marginTop: -80,
      marginBottom: -20,
      flex: 1,
    },
  };
}

export function actionLinkText(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    actionLinkText: {
      color: '#066DFF',
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    actionlinkView: {
      alignSelf: 'flex-start',
      borderBottomColor: Styles.primaryColor,
      borderBottomWidth: 1.5,
    },
  };
}

export function getWelcomeButtonStyles(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    topButton: {
      marginTop: Styles.Spacing.m3,
      alignSelf: 'auto',
      paddingVertical: Styles.Spacing.m1,
    },
  };
}

export function getContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    container: {
      marginTop: 120,
    },
  };
}

export function locationCodebgColor(): string {
  return '#066DFF';
}

export function renderPointsToNextRewardLbl(_styles, nextPoint) {
  const morePointsThanHigher = nextPoint < 0 ? true : false;
  return (
    <>
      <AVText
        style={_styles.pointsToNextRwd}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        testID="qa_RewardsNote_txt"
        nativeID="qa_RewardsNote_txt"
        adjustsFontSizeToFit={true}
        accessible
      >
        {!morePointsThanHigher
          ? Localized.Labels.formatString(
              Localized.Labels.points_next_rewrd,
              nextPoint,
            )
          : Localized.Labels.more_points_than_available}
      </AVText>
    </>
  );
}
export function onboardingLinklocationSuccessTextColor(): string {
  return Styles.Colors.PayNew.primary01;
}
export function getOnBoardingButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  return (
    <>
      <RoundedAppButton
        buttonViewStyle={{height: 43, width: '100%'}}
        textStyle={[
          {
            fontSize: getLayoutDescriber().bodyFontSize(),
            fontWeight: '700',
          },
          getSnackDescriber().snackDetailsBtnFontSTyle(),
          {
            flex: 1,
            textAlign: 'center',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm13}
        isDisabled={disabled}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
          height: 43,
          width: '100%',
        }}
        inActiveTextStyle={{
          fontSize: getLayoutDescriber().bodyFontSize(),
          flex: 1,
          textAlign: 'center',
        }}
        buttonType={RoundedAppButtonType.Solid}
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
      />
    </>
  );
}

export function getLinkLocationButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  const width = Dimensions.get('window').width;
  return (
    <View
      style={{
        marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
        marginTop: Styles.Spacing.m3,
        alignSelf: 'center',
        width: Platform.OS === 'web' ? '100%' : null,
      }}
    >
      <RoundedAppButton
        buttonViewStyle={{width: '100%'}}
        buttonContainerStyle={{
          width: Platform.OS === 'web' ? '100%' : width,
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        }}
        textStyle={[
          {
            fontSize: getLayoutDescriber().bodyFontSize(),
            fontWeight: '700',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        isDisabled={disabled}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
          width: '100%',
        }}
        inActiveTextStyle={{fontSize: getLayoutDescriber().bodyFontSize()}}
        buttonType={RoundedAppButtonType.Solid}
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
      />
    </View>
  );
}

export function getStatusSystem(): string {
  return Localized.Labels.pay_status_system;
}
export function getOneTimeTitle(): string {
  return Localized.Labels.one_time_rewards_title;
}
export function getOneTimePayEarnColor(): string {
  return '#006DFF';
}
export function getLetsGoStyle() {
  return null;
}

export function getBodyTextStyles(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    bodyText: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m3 + Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontStyle: 'normal',
    },
    supportingText: {
      fontFamily: Styles.FontFamily.aeonikRegular,
      fontSize: getLayoutDescriber().bodySmallFontSize(),
      fontStyle: 'normal',
      fontWeight: '400',
      color: Styles.Colors.PayNew.darkHuesBase03,
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m3 + Styles.Spacing.m2,
    },
    forgotPin: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.aeonikRegular,
      marginRight: Styles.Spacing.m1,
    },
    forgotPinDescription: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginBottom: Styles.Spacing.m2,
      marginTop: -Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.aeonikRegular,
      marginRight: Styles.Spacing.m1,
      fontStyle: 'italic',
    },
  };
}

export function baseAccountContainerDescriptor(): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    container: {
      backgroundColor: Styles.white,
      paddingBottom: Platform.OS === 'android' ? 10 : 0,
    },
    headerText: {
      marginTop: Styles.Spacing.m3,
      fontSize: getLayoutDescriber().headerFontSize(),
      fontWeight: 'bold',
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
  };
}
export function getRewardsIcon(size, props) {
  return (
    <Svg width={size ?? 70} height="67" viewBox="0 0 70 67" {...props}>
      <Path
        d="M0 33.5C0 15 14.91 0 33.305 0h3.39C55.09 0 70 15 70 33.5S55.09 67 36.695 67h-3.39C14.91 67 0 52 0 33.5zm0 0"
        stroke="none"
        fillRule="nonzero"
        fill="#006dff"
        fillOpacity={0.14902}
      />
      <Path
        d="M33.512 20.36a5.567 5.567 0 00-4.797-2.758h-.137c-3 0-5.433 2.445-5.433 5.464 0 .895.214 1.739.593 2.485h-1.582a2.97 2.97 0 00-2.96 2.98v3.977c0 1.297.824 2.402 1.972 2.812v10.102c0 2.195 1.773 3.976 3.953 3.976H44.88c2.18 0 3.953-1.78 3.953-3.976V35.32a2.985 2.985 0 001.973-2.812V28.53a2.97 2.97 0 00-2.961-2.98h-1.582a5.47 5.47 0 00.593-2.485c0-3.02-2.433-5.464-5.433-5.464h-.137a5.567 5.567 0 00-4.797 2.757L35 22.91l-1.488-2.543zm14.332 8.171v3.977H36.977V28.53zm-14.82 0v3.977H22.155V28.53zm0 6.957v10.93H25.12a.996.996 0 01-.988-.996v-9.934zm3.953 10.93v-10.93h8.89v9.934a.996.996 0 01-.988.996zm4.445-20.867h-4.527l2.148-3.676a2.604 2.604 0 012.242-1.293h.137a2.477 2.477 0 012.469 2.484 2.477 2.477 0 01-2.47 2.485zm-8.399 0h-4.445a2.477 2.477 0 01-2.469-2.485 2.477 2.477 0 012.47-2.484h.136a2.6 2.6 0 012.242 1.293l2.148 3.676zm0 0"
        stroke="none"
        fillRule="nonzero"
        fill="#066dff"
        fillOpacity={1}
      />
    </Svg>
  );
}
export function getTrailBlazerIcon(size, props) {
  if (Platform.OS === 'web') {
    const imageSource = require('src/components/img/svg/rewards/payapp/PayTrailBlazer.png');
    return imageSource ? (
      <Image
        source={imageSource}
        style={[
          {
            width: size ?? 183,
            height: size ?? 182,
          },
          props.style,
        ]}
        resizeMode="contain"
      />
    ) : null;
  } else {
    return (
      <Svg
        width={size ?? 183}
        height={size ?? 182}
        viewBox="0 0 183 182"
        fill="none"
        {...props}
      >
        <Path
          d="M91.5 177.45C139.245 177.45 177.95 138.745 177.95 90.9998C177.95 43.2548 139.245 4.5498 91.5 4.5498C43.755 4.5498 5.04999 43.2548 5.04999 90.9998C5.04999 138.745 43.755 177.45 91.5 177.45Z"
          fill="url(#paint0_linear_6409_9835)"
        />
        <Path
          d="M91.5 163.8C132.083 163.8 164.983 130.901 164.983 90.3175C164.983 49.7342 132.083 16.835 91.5 16.835C50.9168 16.835 18.0175 49.7342 18.0175 90.3175C18.0175 130.901 50.9168 163.8 91.5 163.8Z"
          fill="#E6ECFF"
        />
        <Path
          d="M123.486 121.371H58.8765C55.949 121.371 53.5757 123.744 53.5757 126.672V132.086C53.5757 135.014 55.949 137.387 58.8765 137.387H123.486C126.414 137.387 128.787 135.014 128.787 132.086V126.672C128.787 123.744 126.414 121.371 123.486 121.371Z"
          fill="url(#paint1_linear_6409_9835)"
        />
        <G style="mix-blend-mode:multiply" opacity="0.4">
          <Path
            d="M123.464 134.315H58.8537C55.9417 134.315 53.553 131.927 53.553 129.015V132.086C53.553 134.998 55.9417 137.387 58.8537 137.387H123.464C126.376 137.387 128.764 134.998 128.764 132.086V129.015C128.764 131.927 126.376 134.315 123.464 134.315Z"
            fill="#60A09C"
          />
        </G>
        <Path
          d="M80.6937 119.665H76.4622C76.2347 119.665 76.0527 119.824 76.0527 120.029V141.391C76.0527 142.006 77.7134 144.076 77.7134 144.076C78.1002 144.667 79.0557 144.667 79.4424 144.076C79.4424 144.076 81.1032 142.006 81.1032 141.391V120.029C81.1032 119.824 80.9212 119.665 80.6937 119.665Z"
          fill="#0052BF"
        />
        <Path
          d="M78.6007 133.429H78.5324C78.4414 133.429 78.3732 133.338 78.3732 133.224V130.972C78.3732 130.904 78.4869 130.676 78.4869 130.676C78.5097 130.608 78.5779 130.608 78.6234 130.676C78.6234 130.676 78.7372 130.904 78.7372 130.972V133.224C78.7372 133.338 78.6689 133.429 78.5779 133.429H78.6007Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.3989 131.336C81.3989 131.177 81.2624 131.04 81.1032 131.04H76.0072C75.8479 131.04 75.7114 131.177 75.7114 131.336C75.7114 131.381 75.7114 136.864 75.7114 136.864C75.7114 137.023 75.8479 137.16 76.0072 137.16C76.1664 137.16 76.3029 137.023 76.3029 136.864V131.632H80.7392V136.864C80.7392 137.023 80.8757 137.16 81.0349 137.16C81.1942 137.16 81.3307 137.023 81.3307 136.864C81.3307 136.864 81.3989 131.404 81.3989 131.313V131.336Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.2169 136.933H75.9162C75.489 136.933 75.1427 137.279 75.1427 137.706V138.161C75.1427 138.588 75.489 138.935 75.9162 138.935H81.2169C81.6441 138.935 81.9905 138.588 81.9905 138.161V137.706C81.9905 137.279 81.6441 136.933 81.2169 136.933Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.2169 127.514H75.9162C75.489 127.514 75.1427 127.86 75.1427 128.287V128.742C75.1427 129.169 75.489 129.516 75.9162 129.516H81.2169C81.6441 129.516 81.9905 129.169 81.9905 128.742V128.287C81.9905 127.86 81.6441 127.514 81.2169 127.514Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.8037 120.279H104.035C104.263 120.279 104.445 120.439 104.445 120.621V141.46C104.445 142.074 102.784 144.076 102.784 144.076C102.397 144.645 101.442 144.645 101.055 144.076C101.055 144.076 99.3942 142.074 99.3942 141.46V120.621C99.3942 120.439 99.5762 120.279 99.8037 120.279Z"
          fill="#0052BF"
        />
        <Path
          d="M101.897 133.429H101.965C102.056 133.429 102.124 133.338 102.124 133.224V130.972C102.124 130.904 102.011 130.676 102.011 130.676C101.988 130.608 101.92 130.608 101.874 130.676C101.874 130.676 101.76 130.904 101.76 130.972V133.224C101.76 133.338 101.828 133.429 101.919 133.429H101.897Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.0757 131.336C99.0757 131.177 99.2122 131.04 99.3715 131.04H104.467C104.627 131.04 104.763 131.177 104.763 131.336C104.763 131.381 104.763 136.864 104.763 136.864C104.763 137.023 104.627 137.16 104.467 137.16C104.308 137.16 104.172 137.023 104.172 136.864V131.632H99.7355V136.864C99.7355 137.023 99.599 137.16 99.4397 137.16C99.2805 137.16 99.144 137.023 99.144 136.864C99.144 136.864 99.0757 131.404 99.0757 131.313V131.336Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.2578 138.935H104.559C104.986 138.935 105.332 138.588 105.332 138.161V137.706C105.332 137.279 104.986 136.933 104.559 136.933H99.2578C98.8306 136.933 98.4843 137.279 98.4843 137.706V138.161C98.4843 138.588 98.8306 138.935 99.2578 138.935Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.2578 129.698H104.559C104.986 129.698 105.332 129.352 105.332 128.925V128.47C105.332 128.043 104.986 127.696 104.559 127.696H99.2578C98.8306 127.696 98.4843 128.043 98.4843 128.47V128.925C98.4843 129.352 98.8306 129.698 99.2578 129.698Z"
          fill="#E7E7E7"
        />
        <Path
          d="M90.6128 37.332C87.223 37.332 84.4475 42.3143 84.4475 48.4795H85.8125C85.8125 43.0423 87.951 38.606 90.59 38.606C93.229 38.606 95.3675 43.0195 95.3675 48.4795H96.7325C96.7325 42.3143 93.9798 37.332 90.59 37.332H90.6128Z"
          fill="#003780"
        />
        <Path
          d="M79.1539 34.4055L75.8471 35.1507C74.1679 35.5292 73.1134 37.1972 73.4918 38.8764L76.2726 51.216C76.651 52.8952 78.3191 53.9497 79.9983 53.5713L83.3051 52.826C84.9844 52.4476 86.0389 50.7796 85.6604 49.1003L82.8796 36.7608C82.5012 35.0816 80.8331 34.0271 79.1539 34.4055Z"
          fill="#003780"
        />
        <Path
          d="M97.8388 52.8157L101.146 53.5609C102.825 53.9393 104.493 52.8848 104.871 51.2056L107.652 38.8661C108.031 37.1868 106.976 35.5188 105.297 35.1404L101.99 34.3951C100.311 34.0167 98.6427 35.0712 98.2643 36.7504L95.4835 49.09C95.1051 50.7692 96.1596 52.4372 97.8388 52.8157Z"
          fill="#003780"
        />
        <Path
          d="M118.049 117.617H114.637C111.656 117.617 109.222 115.183 109.222 112.203V95.4587C109.222 94.2984 110.155 93.3657 111.315 93.3657H121.393C122.554 93.3657 123.486 94.2984 123.486 95.4587V112.203C123.486 115.183 121.052 117.617 118.072 117.617H118.049Z"
          fill="url(#paint2_linear_6409_9835)"
        />
        <Path
          d="M114.819 90.8633H119.369C122.053 90.8633 124.214 93.0245 124.214 95.709V97.8248C124.214 98.8485 123.373 99.6903 122.349 99.6903H111.838C110.815 99.6903 109.973 98.8485 109.973 97.8248V95.709C109.973 93.0245 112.134 90.8633 114.819 90.8633Z"
          fill="#0052BF"
        />
        <Path
          d="M60.014 93.2979H70.0922C71.2525 93.2979 72.1852 94.2306 72.1852 95.3908V112.135C72.1852 115.115 69.751 117.549 66.7707 117.549H63.3582C60.378 117.549 57.9437 115.115 57.9437 112.135V95.3908C57.9437 94.2306 58.8765 93.2979 60.0367 93.2979H60.014Z"
          fill="url(#paint3_linear_6409_9835)"
        />
        <Path
          d="M69.569 99.6221H59.0585C58.0348 99.6221 57.193 98.7803 57.193 97.7566V95.6408C57.193 92.9563 59.3543 90.7951 62.0388 90.7951H66.5888C69.2733 90.7951 71.4345 92.9563 71.4345 95.6408V97.7566C71.4345 98.7803 70.5928 99.6221 69.569 99.6221Z"
          fill="#0052BF"
        />
        <Path
          d="M84.4247 50.5732H96.778C107.584 50.5732 116.343 59.332 116.343 70.1382V114.751C116.343 118.573 113.249 121.667 109.427 121.667H71.7757C67.9537 121.667 64.8597 118.573 64.8597 114.751V70.1382C64.8597 59.332 73.6185 50.5732 84.4247 50.5732Z"
          fill="#066DFF"
        />
        <G style="mix-blend-mode:multiply" opacity="0.4">
          <Path
            d="M109.427 118.209H71.7757C67.9765 118.209 64.8597 115.092 64.8597 111.293V114.728C64.8597 118.527 67.9765 121.644 71.7757 121.644H109.427C113.226 121.644 116.343 118.527 116.343 114.728V111.293C116.343 115.092 113.226 118.209 109.427 118.209Z"
            fill="#F8A326"
          />
        </G>
        <Path
          d="M71.753 45.6816H109.495C111.247 45.6816 112.657 47.0921 112.657 48.8439V58.9221C112.657 65.5196 107.311 70.8659 100.714 70.8659H80.5344C73.9369 70.8659 68.5907 65.5196 68.5907 58.9221V48.8439C68.5907 47.0921 70.0012 45.6816 71.753 45.6816Z"
          fill="url(#paint4_linear_6409_9835)"
        />
        <G style="mix-blend-mode:screen" opacity="0.3">
          <Path
            d="M109.472 45.6816H71.7302C70.0012 45.6816 68.568 47.1149 68.568 48.8439V50.3681C68.568 48.6391 70.0012 47.2059 71.7302 47.2059H109.472C111.201 47.2059 112.635 48.6391 112.635 50.3681V48.8439C112.635 47.1149 111.201 45.6816 109.472 45.6816Z"
            fill="#BE4D27"
          />
        </G>
        <Path
          d="M71.753 91.5908H109.495C111.247 91.5908 112.657 93.0013 112.657 94.7531V109.791C112.657 116.388 107.311 121.735 100.714 121.735H80.5344C73.9369 121.735 68.5907 116.388 68.5907 109.791V94.7531C68.5907 93.0013 70.0012 91.5908 71.753 91.5908Z"
          fill="#66A7FF"
        />
        <Path
          d="M71.4117 91.5908H109.814C111.383 91.5908 112.657 92.8648 112.657 94.4346V98.7116C112.657 104.627 107.857 109.404 101.965 109.404H79.306C73.391 109.404 68.6135 104.604 68.6135 98.7116V94.4346C68.6135 92.8648 69.8875 91.5908 71.4572 91.5908H71.4117Z"
          fill="url(#paint5_linear_6409_9835)"
        />
        <Path
          d="M100.85 75.1201H80.3752C78.6539 75.1201 77.2585 76.5155 77.2585 78.2369V83.9244C77.2585 85.6457 78.6539 87.0411 80.3752 87.0411H100.85C102.572 87.0411 103.967 85.6457 103.967 83.9244V78.2369C103.967 76.5155 102.572 75.1201 100.85 75.1201Z"
          fill="url(#paint6_linear_6409_9835)"
        />
        <Path
          d="M92.8194 57.8984H88.3832C88.1557 57.8984 87.9509 58.0804 87.9509 58.2852V82.0362C87.9509 82.7414 89.6799 85.0164 89.6799 85.0164C90.0894 85.6762 91.0904 85.6762 91.4772 85.0164C91.4772 85.0164 93.2062 82.7187 93.2062 82.0362V58.2852C93.2062 58.0577 93.0242 57.8984 92.7739 57.8984H92.8194Z"
          fill="#0052BF"
        />
        <Path
          d="M90.6355 70.5244H90.5672C90.4762 70.5244 90.408 70.4334 90.408 70.2969V67.9537C90.408 67.8854 90.5445 67.6352 90.5445 67.6352C90.5672 67.5669 90.6582 67.5669 90.681 67.6352C90.681 67.6352 90.8175 67.8854 90.8175 67.9537V70.2969C90.8175 70.4107 90.7492 70.5244 90.6582 70.5244H90.6355Z"
          fill="#E7E7E7"
        />
        <Path
          d="M93.5702 68.3175C93.5702 68.1583 93.4337 67.999 93.2517 67.999H87.9509C87.7917 67.999 87.6324 68.1583 87.6324 68.3175C87.6324 68.363 87.6324 74.096 87.6324 74.096C87.6324 74.2553 87.7689 74.4145 87.9509 74.4145C88.1329 74.4145 88.2694 74.278 88.2694 74.096V68.636H92.8877V74.096C92.8877 74.2553 93.0242 74.4145 93.2062 74.4145C93.3882 74.4145 93.5247 74.278 93.5247 74.096C93.5247 74.096 93.5929 68.3858 93.5929 68.3175H93.5702Z"
          fill="#E7E7E7"
        />
        <Path
          d="M93.411 74.165H87.8372C87.3974 74.165 87.041 74.5215 87.041 74.9613V75.4618C87.041 75.9015 87.3974 76.258 87.8372 76.258H93.411C93.8507 76.258 94.2072 75.9015 94.2072 75.4618V74.9613C94.2072 74.5215 93.8507 74.165 93.411 74.165Z"
          fill="#E7E7E7"
        />
        <Path
          d="M93.411 62.585H87.8372C87.3974 62.585 87.041 62.9415 87.041 63.3812V63.8817C87.041 64.3215 87.3974 64.678 87.8372 64.678H93.411C93.8507 64.678 94.2072 64.3215 94.2072 63.8817V63.3812C94.2072 62.9415 93.8507 62.585 93.411 62.585Z"
          fill="#E7E7E7"
        />
        <Path
          d="M90.7037 78.533C90.955 78.533 91.1587 78.3293 91.1587 78.078C91.1587 77.8268 90.955 77.623 90.7037 77.623C90.4524 77.623 90.2487 77.8268 90.2487 78.078C90.2487 78.3293 90.4524 78.533 90.7037 78.533Z"
          fill="#E7E7E7"
        />
        <Path
          d="M90.7037 80.5799C90.955 80.5799 91.1587 80.3762 91.1587 80.1249C91.1587 79.8736 90.955 79.6699 90.7037 79.6699C90.4524 79.6699 90.2487 79.8736 90.2487 80.1249C90.2487 80.3762 90.4524 80.5799 90.7037 80.5799Z"
          fill="#E7E7E7"
        />
        <Path
          d="M90.7037 82.6053C90.955 82.6053 91.1587 82.4016 91.1587 82.1503C91.1587 81.899 90.955 81.6953 90.7037 81.6953C90.4524 81.6953 90.2487 81.899 90.2487 82.1503C90.2487 82.4016 90.4524 82.6053 90.7037 82.6053Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.1259 90.9092H76.8944C76.6669 90.9092 76.4849 91.0912 76.4849 91.3414V117.049C76.4849 117.8 78.1457 120.279 78.1457 120.279C78.5324 120.985 79.4879 120.985 79.8747 120.279C79.8747 120.279 81.5354 117.8 81.5354 117.049V91.3414C81.5354 91.1139 81.3534 90.9092 81.1259 90.9092Z"
          fill="#0052BF"
        />
        <Path
          d="M79.033 109.746H78.9647C78.8737 109.746 78.8055 109.655 78.8055 109.542V107.289C78.8055 107.221 78.9192 106.994 78.9192 106.994C78.942 106.925 79.0102 106.925 79.0557 106.994C79.0557 106.994 79.1695 107.221 79.1695 107.289V109.542C79.1695 109.655 79.1012 109.746 79.0102 109.746H79.033Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.8539 107.653C81.8539 107.494 81.7174 107.357 81.5582 107.357H76.4622C76.3029 107.357 76.1664 107.494 76.1664 107.653C76.1664 107.699 76.1664 113.181 76.1664 113.181C76.1664 113.341 76.3029 113.477 76.4622 113.477C76.6214 113.477 76.7579 113.341 76.7579 113.181V107.949H81.1942V113.181C81.1942 113.341 81.3307 113.477 81.4899 113.477C81.6492 113.477 81.7857 113.341 81.7857 113.181C81.7857 113.181 81.8539 107.721 81.8539 107.63V107.653Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.6492 113.227H76.3484C75.9213 113.227 75.575 113.573 75.575 114V114.455C75.575 114.882 75.9213 115.229 76.3484 115.229H81.6492C82.0764 115.229 82.4227 114.882 82.4227 114.455V114C82.4227 113.573 82.0764 113.227 81.6492 113.227Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.6492 102.147H76.3484C75.9213 102.147 75.575 102.494 75.575 102.921V103.376C75.575 103.803 75.9213 104.149 76.3484 104.149H81.6492C82.0764 104.149 82.4227 103.803 82.4227 103.376V102.921C82.4227 102.494 82.0764 102.147 81.6492 102.147Z"
          fill="#E7E7E7"
        />
        <Path
          d="M81.6492 97.1426H76.3484C75.9213 97.1426 75.575 97.4889 75.575 97.9161V98.3711C75.575 98.7983 75.9213 99.1446 76.3484 99.1446H81.6492C82.0764 99.1446 82.4227 98.7983 82.4227 98.3711V97.9161C82.4227 97.4889 82.0764 97.1426 81.6492 97.1426Z"
          fill="#E7E7E7"
        />
        <Path
          d="M100.236 90.9092H104.467C104.695 90.9092 104.877 91.0912 104.877 91.3414V117.049C104.877 117.8 103.216 120.279 103.216 120.279C102.829 120.985 101.874 120.985 101.487 120.279C101.487 120.279 99.8265 117.8 99.8265 117.049V91.3414C99.8265 91.1139 100.008 90.9092 100.236 90.9092Z"
          fill="#0052BF"
        />
        <Path
          d="M102.329 109.746H102.397C102.488 109.746 102.556 109.655 102.556 109.542V107.289C102.556 107.221 102.443 106.994 102.443 106.994C102.42 106.925 102.352 106.925 102.306 106.994C102.306 106.994 102.192 107.221 102.192 107.289V109.542C102.192 109.655 102.261 109.746 102.352 109.746H102.329Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.5307 107.653C99.5307 107.494 99.6672 107.357 99.8265 107.357H104.922C105.082 107.357 105.218 107.494 105.218 107.653C105.218 107.699 105.218 113.181 105.218 113.181C105.218 113.341 105.082 113.477 104.922 113.477C104.763 113.477 104.627 113.341 104.627 113.181V107.949H100.19V113.181C100.19 113.341 100.054 113.477 99.8947 113.477C99.7355 113.477 99.599 113.341 99.599 113.181C99.599 113.181 99.5307 107.721 99.5307 107.63V107.653Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.7127 115.252H105.013C105.441 115.252 105.787 114.906 105.787 114.478V114.023C105.787 113.596 105.441 113.25 105.013 113.25H99.7127C99.2855 113.25 98.9392 113.596 98.9392 114.023V114.478C98.9392 114.906 99.2855 115.252 99.7127 115.252Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.7127 104.149H105.013C105.441 104.149 105.787 103.803 105.787 103.376V102.921C105.787 102.494 105.441 102.147 105.013 102.147H99.7127C99.2855 102.147 98.9392 102.494 98.9392 102.921V103.376C98.9392 103.803 99.2855 104.149 99.7127 104.149Z"
          fill="#E7E7E7"
        />
        <Path
          d="M99.7127 99.5312H105.013C105.441 99.5312 105.787 99.1849 105.787 98.7578V98.3028C105.787 97.8756 105.441 97.5293 105.013 97.5293H99.7127C99.2855 97.5293 98.9392 97.8756 98.9392 98.3028V98.7578C98.9392 99.1849 99.2855 99.5312 99.7127 99.5312Z"
          fill="#E7E7E7"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_6409_9835"
            x1="5.04999"
            y1="90.9998"
            x2="177.95"
            y2="90.9998"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_6409_9835"
            x1="53.5757"
            y1="129.356"
            x2="128.765"
            y2="129.356"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_6409_9835"
            x1="109.222"
            y1="105.491"
            x2="123.464"
            y2="105.491"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_6409_9835"
            x1="57.9437"
            y1="105.401"
            x2="72.1852"
            y2="105.401"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_6409_9835"
            x1="68.5679"
            y1="58.2624"
            x2="112.635"
            y2="58.2624"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_6409_9835"
            x1="68.568"
            y1="100.486"
            x2="112.635"
            y2="100.486"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_6409_9835"
            x1="77.2585"
            y1="81.0806"
            x2="103.967"
            y2="81.0806"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#066DFF" />
            <Stop offset="1" stopColor="#58C6BB" />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  }
}
export function getLocationCodeText(
  state,
  maxCharacters,
  doSetState,
  locationNote,
) {
  return (
    <CustomTextInput
      label={Localized.Labels.location_code}
      value={state.locationCode}
      accessible={true}
      accessibilityLabel={Localized.Labels.location_code}
      accessibilityHint={Localized.Labels.please_enter_location_code}
      onChangeText={doSetState}
      accessibilityValue={{text: state.locationCode}}
      autoCapitalize="none"
      showHelpText={true}
      helpText={locationNote}
      maxLength={maxCharacters}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      helperStyle={
        Settings.buildType === 'default'
          ? {
              fontFamily: Styles.FontFamily.aeonikRegular,
              fontSize: getLayoutDescriber().bodySmallFontSize(),
              fontWeight: '400',
              left: 10,
            }
          : null
      }
      showShadow={true}
      outlineStyle={{
        borderRadius: 8,
      }}
      testID="qa_fld_LocationCode"
      helpTextTestId="qa_LinkLocationPrompt_txt"
    />
  );
}
export function getMemberTier(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 183 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91.5001 177.45C139.245 177.45 177.95 138.745 177.95 90.9998C177.95 43.2548 139.245 4.5498 91.5001 4.5498C43.755 4.5498 5.05005 43.2548 5.05005 90.9998C5.05005 138.745 43.755 177.45 91.5001 177.45Z"
        fill="url(#paint0_linear_6409_9591)"
      />
      <Path
        d="M91.5 163.8C132.083 163.8 164.982 130.901 164.982 90.3175C164.982 49.7342 132.083 16.835 91.5 16.835C50.9167 16.835 18.0175 49.7342 18.0175 90.3175C18.0175 130.901 50.9167 163.8 91.5 163.8Z"
        fill="#E6ECFF"
      />
      <Path
        d="M116.844 106.925C116.275 107.812 115.865 108.836 115.729 109.951C115.069 114.774 110.041 117.686 105.514 115.843C102.42 114.569 98.8483 115.524 96.8008 118.186C95.4813 119.892 93.5703 120.848 91.6138 121.03L90.9086 122.281L106.652 149.831L114.91 135.135L132.837 134.862L121.735 115.433L116.866 106.925H116.844Z"
        fill="url(#paint1_linear_6409_9591)"
      />
      <Path
        d="M85.0163 118.164C82.9688 115.525 79.3971 114.569 76.3031 115.82C71.7986 117.663 66.7481 114.751 66.0883 109.928C65.9291 108.813 65.5423 107.79 64.9736 106.902V106.948C64.9508 106.948 60.1051 115.411 60.1051 115.411L49.0031 134.839L66.2021 135.636L75.1656 149.786L90.9086 122.236L90.2033 120.985C88.2468 120.803 86.3586 119.847 85.0163 118.141V118.164Z"
        fill="url(#paint2_linear_6409_9591)"
      />
      <Path
        d="M90.2033 121.03L90.9085 122.282L91.6138 121.03C91.136 121.076 90.6583 121.076 90.1805 121.03H90.2033Z"
        fill="url(#paint3_linear_6409_9591)"
      />
      <Path
        d="M90.2033 121.03L90.9085 122.282L91.6138 121.03C91.136 121.076 90.6583 121.076 90.1805 121.03H90.2033Z"
        fill="url(#paint4_linear_6409_9591)"
      />
      <Path
        d="M90.9086 83.6059L100.532 89.1114L107.562 93.1382L95.1173 114.91L91.6138 121.052C93.5703 120.87 95.4586 119.915 96.8008 118.209C98.8483 115.57 102.42 114.614 105.514 115.865C110.019 117.708 115.069 114.796 115.729 109.973C115.888 108.858 116.275 107.835 116.844 106.947L100.418 78.1914L90.9086 83.6287V83.6059Z"
        fill="url(#paint5_linear_6409_9591)"
      />
      <Path
        d="M76.303 115.843C79.397 114.569 82.9688 115.524 85.0163 118.186C86.3358 119.892 88.2468 120.848 90.2033 121.03L74.2555 93.1157L90.9085 83.6062L81.399 78.1689L76.9855 85.9039L64.9735 106.925C65.5423 107.812 65.9518 108.836 66.0883 109.951C66.748 114.774 71.7758 117.686 76.303 115.843Z"
        fill="url(#paint6_linear_6409_9591)"
      />
      <Path
        d="M107.562 93.1153L100.532 89.0885L90.9086 83.583L74.2556 93.0925L90.2034 121.007C90.6811 121.052 91.1589 121.052 91.6366 121.007L95.1401 114.864L107.584 93.0925L107.562 93.1153Z"
        fill="url(#paint7_linear_6409_9591)"
      />
      <Path
        d="M107.562 93.1153L100.532 89.0885L90.9086 83.583L74.2556 93.0925L90.2034 121.007C90.6811 121.052 91.1589 121.052 91.6366 121.007L95.1401 114.864L107.584 93.0925L107.562 93.1153Z"
        fill="url(#paint8_linear_6409_9591)"
      />
      <Path
        d="M96.8008 34.9216C98.8483 37.5606 102.42 38.5161 105.514 37.2649C110.019 35.4221 115.069 38.3341 115.729 43.1571C116.184 46.4786 118.8 49.0949 122.099 49.5271C126.922 50.1869 129.834 55.2146 127.991 59.7419C126.717 62.8359 127.673 66.4076 130.334 68.4551C134.179 71.4354 134.179 77.2594 130.334 80.2396C127.695 82.2871 126.74 85.8589 127.991 88.9529C129.834 93.4574 126.922 98.5079 122.099 99.1676C118.777 99.6226 116.161 102.239 115.729 105.538C115.069 110.361 110.041 113.273 105.514 111.43C102.42 110.156 98.8483 111.111 96.8008 113.773C93.8205 117.618 87.9966 117.618 85.0163 113.773C82.9688 111.134 79.3971 110.179 76.3031 111.43C71.7986 113.273 66.7481 110.361 66.0883 105.538C65.6333 102.216 63.017 99.5999 59.7183 99.1676C54.8953 98.5079 51.9833 93.4801 53.8261 88.9529C55.1001 85.8589 54.1446 82.2871 51.4828 80.2396C47.6381 77.2594 47.6381 71.4354 51.4828 68.4551C54.1218 66.4076 55.0773 62.8359 53.8261 59.7419C51.9833 55.2374 54.8953 50.1869 59.7183 49.5271C63.0398 49.0721 65.656 46.4559 66.0883 43.1571C66.7481 38.3341 71.7758 35.4221 76.3031 37.2649C79.3971 38.5389 82.9688 37.5834 85.0163 34.9216C87.9966 31.0769 93.8205 31.0769 96.8008 34.9216Z"
        fill="url(#paint9_linear_6409_9591)"
      />
      <Path
        d="M114.932 74.3475C114.932 87.224 104.49 97.6662 91.6365 97.6662C78.7827 97.6662 82.8095 96.3467 79.215 94.0945C72.663 89.9767 68.3177 82.674 68.3177 74.3702C68.3177 61.4937 78.76 51.0742 91.6137 51.0742C104.467 51.0742 102.397 53.0762 106.424 56.375C111.611 60.652 114.91 67.113 114.91 74.3702L114.932 74.3475Z"
        fill="#F3F3F3"
      />
      <Path
        d="M105.981 88.6429C113.879 80.7446 113.879 67.939 105.981 60.0407C98.0828 52.1425 85.2772 52.1425 77.3789 60.0407C69.4807 67.939 69.4807 80.7446 77.3789 88.6429C85.2772 96.5411 98.0828 96.5411 105.981 88.6429Z"
        fill="url(#paint10_linear_6409_9591)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_6409_9591"
          x1="5.05005"
          y1="90.9998"
          x2="177.95"
          y2="90.9998"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_6409_9591"
          x1="73.6641"
          y1="128.378"
          x2="132.223"
          y2="128.378"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_6409_9591"
          x1="49.0031"
          y1="128.378"
          x2="107.562"
          y2="128.378"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_6409_9591"
          x1="0.500209"
          y1="121.645"
          x2="0.727709"
          y2="121.645"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_6409_9591"
          x1="49.0031"
          y1="121.645"
          x2="107.562"
          y2="121.645"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_6409_9591"
          x1="0.500066"
          y1="99.5992"
          x2="0.727566"
          y2="99.5992"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_6409_9591"
          x1="49.003"
          y1="99.5994"
          x2="107.562"
          y2="99.5994"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_6409_9591"
          x1="0.500111"
          y1="102.329"
          x2="0.727611"
          y2="102.329"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_6409_9591"
          x1="49.0031"
          y1="102.329"
          x2="107.562"
          y2="102.329"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_6409_9591"
          x1="48.5936"
          y1="74.3474"
          x2="133.224"
          y2="74.3474"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint10_linear_6409_9591"
          x1="71.4419"
          y1="74.3523"
          x2="111.891"
          y2="74.3523"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
export function getEliteBuyerTier(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 183 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91.5 177.45C139.245 177.45 177.95 138.745 177.95 90.9998C177.95 43.2548 139.245 4.5498 91.5 4.5498C43.755 4.5498 5.04999 43.2548 5.04999 90.9998C5.04999 138.745 43.755 177.45 91.5 177.45Z"
        fill="url(#paint0_linear_6409_10013)"
      />
      <Path
        d="M91.7275 164.483C132.311 164.483 165.21 131.583 165.21 91.0001C165.21 50.4168 132.311 17.5176 91.7275 17.5176C51.1442 17.5176 18.245 50.4168 18.245 91.0001C18.245 131.583 51.1442 164.483 91.7275 164.483Z"
        fill="#E6ECFF"
      />
      <Path
        d="M105.082 147.192C105.036 147.192 105.013 147.192 104.968 147.192C104.649 147.192 96.96 146.6 87.4732 143.051C74.847 138.319 65.0872 130.47 59.2632 120.369C49.5262 103.489 46.9782 85.9941 46.546 74.3006C46.091 61.6289 47.8882 53.0294 47.9792 52.6654C48.1612 51.8236 48.9802 51.3004 49.822 51.4824C50.6637 51.6644 51.187 52.4834 51.005 53.3251C51.005 53.4161 49.185 61.9701 49.6627 74.2779C50.095 85.6074 52.5747 102.511 61.9705 118.8C68.8637 130.743 80.1932 136.977 88.497 140.094C97.5742 143.506 105.127 144.075 105.218 144.075C106.083 144.143 106.72 144.871 106.651 145.736C106.606 146.555 105.923 147.169 105.104 147.169L105.082 147.192Z"
        fill="url(#paint1_linear_6409_10013)"
      />
      <Path
        d="M51.8922 44.817C54.8952 45.2265 52.0287 62.4483 48.457 60.9013C44.8852 59.3543 48.0475 44.2938 51.8922 44.817Z"
        fill="#066DFF"
      />
      <Path
        d="M58.2167 62.3343C60.924 64.2453 50.5272 76.371 48.0475 74.0505C45.5677 71.73 55.464 60.4005 58.2167 62.3343Z"
        fill="#066DFF"
      />
      <Path
        d="M37.81 62.3343C35.1027 64.2453 45.4995 76.371 47.9792 74.0505C50.459 71.73 40.5627 60.4005 37.81 62.3343Z"
        fill="#066DFF"
      />
      <Path
        d="M59.1722 74.8011C61.8795 76.7121 51.4827 88.8378 49.003 86.5173C46.5232 84.1968 56.4195 72.8673 59.1722 74.8011Z"
        fill="#066DFF"
      />
      <Path
        d="M38.7655 74.8011C36.0582 76.7121 46.455 88.8378 48.9347 86.5173C51.4145 84.1968 41.5182 72.8673 38.7655 74.8011Z"
        fill="#066DFF"
      />
      <Path
        d="M60.5372 87.3138C63.4947 88.8608 54.9862 102.192 52.188 100.213C49.3897 98.2338 57.5342 85.7441 60.5372 87.3138Z"
        fill="#066DFF"
      />
      <Path
        d="M40.3352 89.9528C37.9237 92.1823 50.004 102.852 52.1197 100.236C54.2355 97.6195 42.7695 87.6778 40.3352 89.9528Z"
        fill="#066DFF"
      />
      <Path
        d="M63.836 100.236C66.9755 101.419 60.3097 115.661 57.284 114.023C54.2582 112.385 60.651 99.0533 63.836 100.236Z"
        fill="#066DFF"
      />
      <Path
        d="M44.1345 105.196C42.0415 107.698 55.4412 116.867 57.193 114.023C58.9447 111.179 46.2502 102.671 44.1345 105.196Z"
        fill="#066DFF"
      />
      <Path
        d="M68.0902 110.701C71.4117 111.338 67.5442 126.467 64.2682 125.352C60.9695 124.26 64.7232 110.041 68.0902 110.701Z"
        fill="#066DFF"
      />
      <Path
        d="M49.6627 118.914C48.093 121.735 63.017 128.492 64.2 125.421C65.383 122.327 51.278 116.07 49.6627 118.914Z"
        fill="#066DFF"
      />
      <Path
        d="M73.664 119.255C77.0537 119.096 77.3722 134.634 73.8915 134.338C70.4107 134.043 70.2287 119.414 73.664 119.255Z"
        fill="#066DFF"
      />
      <Path
        d="M58.0347 131.517C57.2612 134.611 73.5275 137.66 73.846 134.384C74.1645 131.131 58.831 128.378 58.0347 131.517Z"
        fill="#066DFF"
      />
      <Path
        d="M77.7817 147.192C76.9627 147.192 76.303 146.555 76.2347 145.759C76.1665 144.895 76.8262 144.167 77.668 144.098C77.7362 144.098 85.2892 143.53 94.3665 140.117C102.67 137 114.022 130.767 120.893 118.823C130.289 102.534 132.768 85.6081 133.201 74.3013C133.656 61.9936 131.858 53.4168 131.858 53.3486C131.676 52.5068 132.222 51.6878 133.041 51.5058C133.883 51.3238 134.702 51.8471 134.884 52.6888C134.952 53.0528 136.772 61.6296 136.317 74.3241C135.885 86.0176 133.337 103.512 123.6 120.393C117.776 130.494 108.016 138.343 95.3902 143.075C85.9035 146.624 78.214 147.192 77.8955 147.215C77.85 147.215 77.8272 147.215 77.7817 147.215V147.192Z"
        fill="url(#paint2_linear_6409_10013)"
      />
      <Path
        d="M130.994 44.817C127.991 45.2265 130.857 62.4483 134.429 60.9013C138.001 59.3543 134.839 44.2938 130.994 44.817Z"
        fill="#066DFF"
      />
      <Path
        d="M124.669 62.3343C121.962 64.2453 132.359 76.371 134.839 74.0505C137.318 71.73 127.422 60.4005 124.669 62.3343Z"
        fill="#066DFF"
      />
      <Path
        d="M145.076 62.3343C147.783 64.2453 137.387 76.371 134.907 74.0505C132.427 71.73 142.323 60.4005 145.076 62.3343Z"
        fill="#066DFF"
      />
      <Path
        d="M123.714 74.8011C121.007 76.7121 131.403 88.8378 133.883 86.5173C136.363 84.1968 126.467 72.8673 123.714 74.8011Z"
        fill="#066DFF"
      />
      <Path
        d="M144.098 74.8011C146.805 76.7121 136.408 88.8378 133.929 86.5173C131.449 84.1968 141.345 72.8673 144.098 74.8011Z"
        fill="#066DFF"
      />
      <Path
        d="M122.326 87.3138C119.369 88.8608 127.877 102.192 130.676 100.213C133.474 98.2338 125.329 85.7441 122.326 87.3138Z"
        fill="#066DFF"
      />
      <Path
        d="M142.551 89.9528C144.963 92.1823 132.882 102.852 130.766 100.236C128.651 97.6195 140.117 87.6778 142.551 89.9528Z"
        fill="#066DFF"
      />
      <Path
        d="M119.027 100.236C115.888 101.419 122.554 115.661 125.579 114.023C128.605 112.385 122.212 99.0533 119.027 100.236Z"
        fill="#066DFF"
      />
      <Path
        d="M138.729 105.196C140.822 107.698 127.422 116.867 125.671 114.023C123.919 111.179 136.613 102.671 138.729 105.196Z"
        fill="#066DFF"
      />
      <Path
        d="M114.796 110.701C111.474 111.338 115.342 126.467 118.618 125.352C121.917 124.26 118.163 110.041 114.796 110.701Z"
        fill="#066DFF"
      />
      <Path
        d="M133.223 118.914C134.793 121.735 119.869 128.492 118.686 125.421C117.503 122.327 131.608 116.07 133.223 118.914Z"
        fill="#066DFF"
      />
      <Path
        d="M109.199 119.255C105.81 119.096 105.491 134.634 108.972 134.338C112.453 134.043 112.635 119.414 109.199 119.255Z"
        fill="#066DFF"
      />
      <Path
        d="M124.851 131.517C125.625 134.611 109.359 137.66 109.04 134.384C108.722 131.131 124.055 128.378 124.851 131.517Z"
        fill="#066DFF"
      />
      <Path
        d="M95.3902 100.782H88.224L88.4743 98.2345L89.7027 86.4272L89.9985 83.4697H93.6157L95.3902 100.782Z"
        fill="#0052BF"
      />
      <Path
        d="M92.8423 98.1209L88.4743 98.2347L89.7028 86.4274L91.955 86.2227L92.8423 98.1209Z"
        fill="#066DFF"
      />
      <Path
        d="M96.869 98.6213V100.009C96.869 100.396 96.5505 100.737 96.1638 100.737H87.4505C87.0638 100.737 86.7453 100.419 86.7453 100.009V98.6213C86.7453 98.2345 87.0638 97.916 87.4505 97.916H96.1638C96.5505 97.916 96.869 98.2345 96.869 98.6213Z"
        fill="#66A7FF"
      />
      <Path
        d="M96.869 98.6213V100.009C96.869 100.396 96.5505 100.737 96.1638 100.737H87.4505C87.0638 100.737 86.7453 100.419 86.7453 100.009V99.5768C88.7473 99.6223 94.0252 99.7588 94.412 99.5768C94.7987 99.372 94.412 98.3255 94.23 97.916H96.141C96.5278 97.916 96.8463 98.2345 96.8463 98.6213H96.869Z"
        fill="#066DFF"
      />
      <Path
        d="M109.586 110.724H74.028L74.2555 108.858L75.3247 100.714H108.267L109.336 108.858L109.586 110.724Z"
        fill="url(#paint3_linear_6409_10013)"
      />
      <Path
        d="M109.586 110.724H74.028L74.2555 108.858H109.336L109.586 110.724Z"
        fill="#0052BF"
      />
      <Path
        d="M110.109 110.724H73.5047C72.7312 110.724 72.0943 111.361 72.0943 112.134C72.0943 112.908 72.7312 113.545 73.5047 113.545H110.109C110.883 113.545 111.52 112.908 111.52 112.134C111.52 111.361 110.883 110.724 110.109 110.724Z"
        fill="#066DFF"
      />
      <Path
        d="M112.817 66.4754L103.785 75.2796L105.923 87.7239C106.219 89.4074 104.445 90.6814 102.943 89.8851L91.773 84.0156L80.6027 89.8851C79.8065 90.2946 78.942 90.1354 78.3505 89.6576C77.8045 89.2254 77.486 88.5201 77.6225 87.7011L79.761 75.2569L70.7293 66.4526C69.5008 65.2696 70.1833 63.1766 71.8668 62.9491L84.3565 61.1291L89.9302 49.8224C90.3397 48.9806 91.2042 48.5939 92.0232 48.6849C92.6602 48.7531 93.2972 49.1399 93.6157 49.8224L99.1895 61.1291L111.679 62.9491C113.363 63.1994 114.045 65.2696 112.817 66.4526V66.4754Z"
        fill="url(#paint4_linear_6409_10013)"
      />
      <Path
        d="M91.045 54.5996C92.6147 54.5996 89.4752 64.1319 87.5415 63.6541C85.6077 63.1764 89.7027 54.5996 91.045 54.5996Z"
        fill="#F3F3F3"
      />
      <Path
        d="M78.487 65.0876C78.0093 66.1341 84.766 66.6573 84.8798 65.8156C84.9935 64.9738 79.1013 63.7681 78.487 65.0876Z"
        fill="#F3F3F3"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_6409_10013"
          x1="5.04999"
          y1="90.9998"
          x2="177.95"
          y2="90.9998"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_6409_10013"
          x1="46.4777"
          y1="99.3256"
          x2="106.629"
          y2="99.3256"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#58C6BB" />
          <Stop offset="1" stopColor="#066DFF" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_6409_10013"
          x1="76.2347"
          y1="99.3263"
          x2="136.408"
          y2="99.3263"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_6409_10013"
          x1="74.028"
          y1="105.719"
          x2="109.586"
          y2="105.719"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_6409_10013"
          x1="70.0695"
          y1="69.4101"
          x2="111.611"
          y2="69.4101"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
export function getTrialBlazerWebIcon() {
  return <TRialBlazerIconWeb />;
}

export function getSmartShopper(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 183 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91.5 177.45C139.245 177.45 177.95 138.745 177.95 90.9998C177.95 43.2548 139.245 4.5498 91.5 4.5498C43.755 4.5498 5.05005 43.2548 5.05005 90.9998C5.05005 138.745 43.755 177.45 91.5 177.45Z"
        fill="url(#paint0_linear_6409_9693)"
      />
      <Path
        d="M91.5 164.483C132.083 164.483 164.982 131.583 164.982 91.0001C164.982 50.4168 132.083 17.5176 91.5 17.5176C50.9167 17.5176 18.0175 50.4168 18.0175 91.0001C18.0175 131.583 50.9167 164.483 91.5 164.483Z"
        fill="#E6ECFF"
      />
      <Path
        d="M126.262 74.7797C126.262 54.9644 109.677 39.0394 89.6345 40.0859C71.6848 41.0414 57.1703 56.0564 56.7835 74.0289C56.5333 85.9044 62.2435 96.4376 71.1388 102.899C72.9815 104.241 74.1418 106.334 74.1418 108.609V109.382C74.1418 111.453 75.6888 113 77.6225 113H105.423C107.334 113 108.904 111.453 108.904 109.519V108.586C108.904 106.311 110.041 104.241 111.884 102.899C120.597 96.5969 126.285 86.3594 126.285 74.7569H126.262V74.7797Z"
        fill="#D5DDF5"
      />
      <Path
        d="M126.262 74.7796H127.513C127.513 64.8378 123.486 55.8288 116.957 49.3223C110.451 42.8158 101.442 38.7891 91.5 38.7891C90.863 38.7891 90.226 38.7891 89.5662 38.8346C80.2615 39.3351 71.844 43.4756 65.7242 49.8001C59.6045 56.1246 55.737 64.6786 55.5322 74.0061C55.5322 74.2563 55.5322 74.5293 55.5322 74.7796C55.5322 80.7628 56.9882 86.4276 59.5817 91.3871C62.1752 96.3466 65.8835 100.646 70.4107 103.922C71.1842 104.491 71.7985 105.196 72.2307 106.015C72.663 106.812 72.8905 107.699 72.8905 108.632V109.405C72.8905 110.747 73.391 111.976 74.2555 112.863C74.6877 113.295 75.1882 113.659 75.757 113.91C76.3257 114.16 76.9627 114.274 77.5997 114.274H105.4C106.697 114.274 107.88 113.75 108.744 112.886C109.609 112.044 110.132 110.838 110.132 109.542V108.609C110.132 107.676 110.36 106.789 110.792 105.993C111.224 105.196 111.838 104.491 112.612 103.922C117.116 100.669 120.847 96.3693 123.464 91.4098C126.057 86.4503 127.536 80.7856 127.536 74.7796V71.7538L125.375 73.9151L126.262 74.8023L127.149 75.6896H127.172L126.285 74.7796H125.033C125.033 80.3761 123.668 85.6313 121.234 90.2496C118.823 94.8678 115.342 98.8718 111.133 101.898C110.064 102.671 109.199 103.672 108.585 104.81C107.971 105.947 107.63 107.244 107.63 108.586V109.519C107.63 110.133 107.379 110.702 106.97 111.089C106.56 111.498 106.014 111.748 105.4 111.748H77.5997C77.2812 111.748 76.9855 111.68 76.7352 111.566C76.3485 111.407 76.0072 111.111 75.757 110.747C75.5067 110.383 75.3702 109.928 75.3702 109.382V108.609C75.3702 107.267 75.029 105.97 74.4147 104.81C73.8005 103.672 72.936 102.671 71.844 101.875C67.6352 98.8263 64.1772 94.8451 61.7657 90.2041C59.3542 85.5858 57.9892 80.3306 57.9892 74.7568C57.9892 74.5066 57.9892 74.2791 57.9892 74.0288C58.1712 65.3838 61.7657 57.4213 67.476 51.5291C73.1862 45.6141 81.0122 41.7693 89.6572 41.3143C90.2715 41.2916 90.863 41.2688 91.4545 41.2688C100.714 41.2688 109.086 45.0226 115.16 51.0741C121.234 57.1483 124.965 65.4976 124.965 74.7568V77.7826L127.104 75.6441L126.216 74.7568L126.262 74.7796Z"
        fill="url(#paint1_linear_6409_9693)"
      />
      <Path
        d="M77.6225 127.832V129.084H105.4C106.014 129.084 106.56 129.334 106.97 129.743C107.379 130.153 107.63 130.699 107.63 131.313C107.63 131.927 107.379 132.473 106.97 132.883C106.56 133.292 106.014 133.543 105.4 133.543H77.6225C77.0082 133.543 76.4623 133.292 76.0528 132.883C75.6433 132.473 75.393 131.927 75.393 131.313C75.393 130.699 75.6433 130.153 76.0528 129.743C76.4623 129.334 77.0082 129.084 77.6225 129.084V126.581C76.3258 126.581 75.12 127.104 74.2782 127.969C73.4137 128.811 72.8905 130.016 72.8905 131.313C72.8905 132.61 73.4137 133.793 74.2782 134.657C75.12 135.499 76.3258 136.045 77.6225 136.045H105.4C106.697 136.045 107.903 135.522 108.744 134.657C109.609 133.816 110.132 132.61 110.132 131.313C110.132 130.016 109.609 128.833 108.744 127.969C107.903 127.127 106.697 126.581 105.4 126.581H77.6225V127.832Z"
        fill="url(#paint2_linear_6409_9693)"
      />
      <Path
        d="M98.4615 112.999H94.9808V83.4694H88.042V112.999H84.5613V83.4694H80.216C75.9163 83.4694 72.39 79.9659 72.39 75.6434C72.39 71.3209 75.8935 67.8174 80.216 67.8174C84.5385 67.8174 88.042 71.3209 88.042 75.6434V79.9886H94.9808V75.6434C94.9808 71.3436 98.4843 67.8174 102.807 67.8174C107.129 67.8174 110.633 71.3209 110.633 75.6434C110.633 79.9659 107.129 83.4694 102.807 83.4694H98.4615V112.999ZM98.4615 79.9886H102.807C105.196 79.9886 107.152 78.0321 107.152 75.6434C107.152 73.2546 105.196 71.2981 102.807 71.2981C100.418 71.2981 98.4615 73.2546 98.4615 75.6434V79.9886ZM80.216 71.3209C77.8273 71.3209 75.8708 73.2774 75.8708 75.6661C75.8708 78.0549 77.8273 80.0114 80.216 80.0114H84.5613V75.6661C84.5613 73.2774 82.6048 71.3209 80.216 71.3209Z"
        fill="url(#paint3_linear_6409_9693)"
      />
      <Path
        d="M77.6225 120.439V121.69H105.4C106.014 121.69 106.56 121.94 106.97 122.35C107.379 122.759 107.63 123.305 107.63 123.919C107.63 124.534 107.379 125.08 106.97 125.489C106.56 125.899 106.014 126.149 105.4 126.149H77.6225C77.0082 126.149 76.4623 125.899 76.0528 125.489C75.6433 125.08 75.393 124.534 75.393 123.919C75.393 123.305 75.6433 122.759 76.0528 122.35C76.4623 121.94 77.0082 121.69 77.6225 121.69V119.188C76.3258 119.188 75.12 119.711 74.2782 120.575C73.4137 121.417 72.8905 122.623 72.8905 123.919C72.8905 125.216 73.4137 126.399 74.2782 127.264C75.12 128.106 76.3258 128.651 77.6225 128.651H105.4C106.697 128.651 107.903 128.128 108.744 127.264C109.609 126.422 110.132 125.216 110.132 123.919C110.132 122.623 109.609 121.44 108.744 120.575C107.903 119.733 106.697 119.188 105.4 119.188H77.6225V120.439Z"
        fill="url(#paint4_linear_6409_9693)"
      />
      <Path
        d="M77.6225 113.022V114.273H105.4C106.014 114.273 106.56 114.523 106.97 114.933C107.379 115.342 107.63 115.888 107.63 116.503C107.63 117.117 107.379 117.663 106.97 118.072C106.56 118.482 106.014 118.732 105.4 118.732H77.6225C77.0082 118.732 76.4623 118.482 76.0528 118.072C75.6433 117.663 75.393 117.117 75.393 116.503C75.393 115.888 75.6433 115.342 76.0528 114.933C76.4623 114.523 77.0082 114.273 77.6225 114.273V111.771C76.3258 111.771 75.12 112.294 74.2782 113.158C73.4137 114 72.8905 115.206 72.8905 116.503C72.8905 117.799 73.4137 118.982 74.2782 119.847C75.12 120.689 76.3258 121.235 77.6225 121.235H105.4C106.697 121.235 107.903 120.711 108.744 119.847C109.609 119.005 110.132 117.799 110.132 116.503C110.132 115.206 109.609 114.023 108.744 113.158C107.903 112.317 106.697 111.771 105.4 111.771H77.6225V113.022Z"
        fill="url(#paint5_linear_6409_9693)"
      />
      <Path
        d="M81.0806 135.932H101.92C101.92 139.776 98.8028 142.87 94.9808 142.87H88.0421C84.1973 142.87 81.1033 139.754 81.1033 135.932H81.0806Z"
        fill="#4D4D4D"
      />
      <Path
        d="M118.027 58.2168L115.092 60.0595C116.07 61.6065 116.889 63.2673 117.526 64.9735L120.779 63.7451C120.051 61.8341 119.141 59.9685 118.049 58.2168H118.027Z"
        fill="white"
      />
      <Path
        d="M100.919 48.6168C104.718 49.9818 108.267 52.2341 111.133 55.1006L113.59 52.6436C110.36 49.4131 106.379 46.8878 102.079 45.3408L100.896 48.6168H100.919Z"
        fill="white"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_6409_9693"
          x1="5.05005"
          y1="90.9998"
          x2="177.95"
          y2="90.9998"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_6409_9693"
          x1="55.5322"
          y1="70.1841"
          x2="127.536"
          y2="70.1841"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_6409_9693"
          x1="72.8905"
          y1="131.29"
          x2="110.132"
          y2="131.29"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_6409_9693"
          x1="72.39"
          y1="90.4081"
          x2="110.633"
          y2="90.4081"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_6409_9693"
          x1="72.8905"
          y1="123.897"
          x2="110.132"
          y2="123.897"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_6409_9693"
          x1="72.8905"
          y1="116.48"
          x2="110.132"
          y2="116.48"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset="1" stopColor="#58C6BB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export function getGoToSettings() {
  return Localized.Buttons.go_to_settings_receipt;
}

export function seeMoreDetailtxt() {
  return capitalizeFirstWord(Localized.Buttons.see_more_details);
}
export function getManualLinktxt() {
  return Localized.Buttons.manually_link_your_location;
}
export function locationCodeSaveButtonTextStyle(): StyleProp<TextStyle> {
  return {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    fontFamily: Styles.FontFamily.figtreeRegular,
  };
}
export default {
  getOnBoardingButton,
  linkExistingAccountStyleDescriptor,
  getWelcomeStatusBarStyleDescriptor,
  getWelcomeViewBckGrndStyleDescriptor,
  baseAccountContainerDescriptor,
  getOrTextDescriptor,
  getGoToSettings,
  getVersionTextDescriptor,
  getLogoContainer,
  getContainer,
  getManualLinktxt,
  getWelcomeOverLayImage,
  getRedeemColor,
  getTrailBlazerIcon,
  getSmartShopper,
  renderPointsToNextRewardLbl,
  getFocusAwareStatusBar,
  getLineContainer,
  getWelcomeButtonStyles,
  locationCodebgColor,
  getLetsGoStyle,
  getOneTimePayEarnColor,
  getRewardsIcon,
  renderYourBalanceRewardLbl,
  actionLinkText,
  getEliteBuyerTier,
  onboardingLinklocationSuccessTextColor,
  getBodyTextStyles,
  getOneTimeTitle,
  getStatusSystem,
  seeMoreDetailtxt,
  getMemberTier,
  getLocationCodeText,
  locationCodeSaveButtonTextStyle,
  getTrialBlazerWebIcon,
  getPasswordLoginTextStyleDescriptor,
  getLinkLocationButton,
};
